// extracted by mini-css-extract-plugin
export default {"Loading":"ChatArea_Loading__Uu+EO","AuthPrompt":"ChatArea_AuthPrompt__imx5W","AuthText":"ChatArea_AuthText__-NX75","AuthButton":"ChatArea_AuthButton__EhztT"};